import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { apiCall } from "../../../services/api-service.js";
// ...existing code...
import { ReactComponent as CalendarIcon } from "../../../Assets/svg/calendar.svg";
import { Container, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import greyIcon from "../../../Assets/svg/grey.svg";
import yellowIcon from "../../../Assets/svg/yellow.svg";
import SearchWithAPI from "../../common/searchbox/searchbox.js";
import ModalCloseIcon from "../../../Assets/svg/close-modal.svg";

const TicketDateInput = React.forwardRef(function TicketDateInput(
  { value, onClick, placeholder },
  ref
) {
  return (
    <input
      ref={ref}
      value={value}
      onClick={onClick}
      readOnly
      className="form-control w-100"
      style={{
        height: "40px",
        borderRadius: "10px",
        border: "0.7px solid #E5E5E5",
        padding: "16px",
        cursor: "pointer",
      }}
      placeholder={placeholder}
    />
  );
});
const BulkStatusUpdateModal = ({ ticketList, onHide, success }) => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const modalStyle = {
    overlay: {
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      opacity: 1,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      zIndex: 1000,
    },
    modal: {
      backgroundColor: "#ffffff",
      padding: "20px 24px",
      borderRadius: "16px",
      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)",
      width: "1200px",
      maxWidth: "96vw",
      height: "88vh",
      maxHeight: "900px",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
  };

  function modalTitle(updateStatus) {
    if (updateStatus === "Hold") {
      return "Holding remarks";
    } else if (updateStatus === "Closed") {
      return "Closing remarks";
    } else if (updateStatus === "Completed") {
      return "Completing remarks";
    } else {
      return "";
    }
  }
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  const [descriptionInputValue, setDescriptionInputValue] = useState("");
  const [lastKey, setLastKey] = useState("");
  const [showPicker, setShowPicker] = useState(false);
  const [selectedProjectOption, setProjectOption] = useState(null);
  const [selectedComponentOption, setComponentOption] = useState(null);
  const [selectedTeamOption, setTeamOption] = useState(null);
  const [selectedAssignToOption, setAssignToOption] = useState(null);
  const [remarkType, setRemarksType] = useState("single");

  const [selectedTicketList, setSelectedTicketList] = useState([]);
  const [groupedError, setGroupedError] = useState({});
  // const handleTeamDropdownChange = (option) => {
  //   setTeamOption(option);
  // };
  const handleTeamDropdownChange = (option) => {
    setTeamOption(option);
    setSelectedTicketList(
      selectedTicketList.map((item) => ({
        ...item,
        teamOption: option,
      }))
    );
  };
  const handleAssignToDropdownChange = (option) => {
    setAssignToOption(option);
    setSelectedTicketList(
      selectedTicketList.map((item) => ({
        ...item,
        assignToOption: option,
      }))
    );
  };
  // const handleAssignToDropdownChange = (option) => {
  //   setAssignToOption(option);
  // };
  useEffect(() => {
    const updated = ticketList.map((item) => ({
      ...item,
      projectOption: {
        value: item.project_id ?? "",
        label: item.project ?? "",
      },
      componentOption: {
        value: item.component_id ?? "",
        label: item.component ?? "",
      },
      teamOption: {
        value: item.team_id ?? "",
        label: item.team ?? "",
      },
      assignToOption: {
        value: item.assign_to_id ?? "",
        label: item.assigned_to ?? "",
      },
      work_duration:
        (item.work_duration && item.work_duration !== "--:--"
          ? item.work_duration.substring(0, 5)
          : "") ||
        (item.duration && item.duration !== "--:--"
          ? item.duration.substring(0, 5)
          : "") ||
        (item.closed_duration ? item.closed_duration.substring(0, 5) : "") ||
        "",
      closing_date: moment(new Date()).format("YYYY-MM-DD"), // today
      expected_date: moment(new Date()).format("YYYY-MM-DD"), // today
      isChecked: true,
      description: "",
    }));

    setSelectedTicketList(updated);

    // Attach event listener to the document
    document.addEventListener("mousedown", handleCloseDatePicker);
    return () => {
      // Clean up event listener on unmount
      document.removeEventListener("mousedown", handleCloseDatePicker);
    };
  }, []);
  const alertDatePicRef = useRef(null);
  const [alertIndex, setAlertIndex] = useState(null);
  const handleCloseDatePicker = (event) => {
    if (
      alertDatePicRef.current &&
      !alertDatePicRef.current.contains(event.target)
    ) {
      setShowPicker(false);
    }
  };

  const [validations, setValidations] = useState({
    status: "",
    project_id: "",
    component_id: "",
    description: "",
    tickets: "",
  });

  const statusUpdateApi = async () => {
    const data = {
      status: status || null, //Hold,In Progress,Closed,Completed
      project_id:
        selectedProjectOption != null ? selectedProjectOption.value : null,
      component_id:
        selectedComponentOption != null ? selectedComponentOption.value : "",
      description: remarkType === "single" ? (descriptionInputValue || null) : null,
      team_id: selectedTeamOption != null ? selectedTeamOption.value : null,
      assignee:
        selectedAssignToOption != null ? selectedAssignToOption.value : null,
      tickets: selectedTicketList
        .filter((item) => item.isChecked === true)
        .map((item) => ({
          id: item.id,
          project_id:
            item.projectOption != null ? item.projectOption.value : null,
          component_id:
            item.componentOption != null ? item.componentOption.value : "",
          team_id: item.teamOption != null ? item.teamOption.value : null,
          assignee:
            item.assignToOption != null ? item.assignToOption.value : null,
          closing_date: item.closing_date || null,
          work_duration: item.work_duration || null,
          expected_date: item.expected_date || null,
          description: remarkType === "single" ? (descriptionInputValue || null) : (item.description || null),
        })),
    };

    const response = await apiCall("put", "ticket/bulk_update", data);
    if (response?.status === 200 && response?.data?.success === true) {
      success();
    } else if (response?.status === 400 && response?.data?.error) {
      const validationTemp = {
        status: "",
        project_id: "",
        component_id: "",
        description: "",
        tickets: "",
      };
      const groupedErrorTemp = {};
      Object.entries(response.data.error).forEach(([key, value]) => {
        // match tickets.index.field
        const match = key.match(/^tickets\.(\d+)\.(.+)$/);

        if (match) {
          const index = match[1]; // e.g. "0"
          const field = match[2]; // e.g. "closing_date"

          if (!groupedErrorTemp[index]) groupedErrorTemp[index] = {};
          groupedErrorTemp[index][field] = value;
        }
      });
      Object.entries(response.data.error).forEach(([key, value]) => {
        validationTemp[key] = value.length === 0 ? "" : value[0];
      });
      setGroupedError(groupedErrorTemp);
      setValidations(validationTemp);
    }
  };

  const handleProjectDropdownChange = (option) => {
    setProjectOption(option);
    setSelectedTicketList(
      selectedTicketList.map((item) => ({
        ...item,
        projectOption: option,
      }))
    );
  };
  const handleComponentDropdownChange = (option) => {
    setComponentOption(option);
    setSelectedTicketList(
      selectedTicketList.map((item) => ({
        ...item,
        componentOption: option,
      }))
    );
  };
  const handleChangeRadio = (event) => {
    setRemarksType(event.target.value);
  };
  const handleProjectListChange = (selectedOptions, onChangeIndex) => {
    const tempList = [...selectedTicketList];
    if (tempList[onChangeIndex.parentIndex] !== undefined) {
      tempList[onChangeIndex.parentIndex].projectOption = selectedOptions;
      setSelectedTicketList(tempList);
    }
  };
  const handleTeamListChange = (selectedOptions, onChangeIndex) => {
    const tempList = [...selectedTicketList];
    if (tempList[onChangeIndex.parentIndex] !== undefined) {
      tempList[onChangeIndex.parentIndex].teamOption = selectedOptions;
      setSelectedTicketList(tempList);
    }
  };
  const handleComponentListChange = (selectedOptions, onChangeIndex) => {
    const tempList = [...selectedTicketList];
    if (tempList[onChangeIndex.parentIndex] !== undefined) {
      tempList[onChangeIndex.parentIndex].componentOption = selectedOptions;
      setSelectedTicketList(tempList);
    }
  };
  const handleAssignToListChange = (selectedOptions, onChangeIndex) => {
    const tempList = [...selectedTicketList];
    if (tempList[onChangeIndex.parentIndex] !== undefined) {
      tempList[onChangeIndex.parentIndex].assignToOption = selectedOptions;
      setSelectedTicketList(tempList);
    }
  };
  
  const getErrorMsg = (index, field) => {
    if (field === "project_id") {
      if (groupedError[index] != null) {
        if (groupedError[index].project_id != null) {
          return (
            groupedError[index].project_id[0]?.replace(
              `tickets.${index}.project_id`,
              "project"
            ) ?? ""
          );
        }
      }
    }
    if (field === "component_id") {
      if (groupedError[index] != null) {
        if (groupedError[index].component_id != null) {
          return (
            groupedError[index].component_id[0]?.replace(
              `tickets.${index}.component_id`,
              "component"
            ) ?? ""
          );
        }
      }
    }
    if (field === "closing_date") {
      if (groupedError[index] != null) {
        if (groupedError[index].closing_date != null) {
          return (
            groupedError[index].closing_date[0]?.replace(
              `tickets.${index}.closing_date`,
              "closing date"
            ) ?? ""
          );
        }
      }
    }
    if (field === "work_duration") {
      if (groupedError[index] != null) {
        if (groupedError[index].work_duration != null) {
          return (
            groupedError[index].work_duration[0]?.replace(
              `tickets.${index}.work_duration`,
              "working duration"
            ) ?? ""
          );
        }
      }
    }
    if (field === "description") {
      if (groupedError[index] != null) {
        if (groupedError[index].description != null) {
          return (
            groupedError[index].description[0]?.replace(
              `tickets.${index}.description`,
              "description"
            ) ?? ""
          );
        }
      }
    }

    return "";
  };
  return (
    <div style={modalStyle.overlay}>
      <div style={modalStyle.modal}>
        <div style={{ color: "#ffffff", height: "100%", display: "flex", flexDirection: "column", minHeight: 0 }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexShrink: 0,
              paddingBottom: "8px",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "start",
              }}
            >
              <div
                style={{
                  paddingLeft: "4px",
                  fontSize: "20px",
                  fontWeight: "500",
                  color: "#212129",
                }}
              >
                Bulk Ticket Update
              </div>
            </div>
            <div className="style-justify-end">
              {status !== "" && (
                <button
                  style={{
                    marginRight: "4px",
                    height: "40px",
                    borderRadius: "100px",
                    padding: "10px 28px 10px 28px",
                    gap: "10px",
                    backgroundColor: "#2C8C53",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    fontFamily: "Satoshi",
                    fontSize: "14px",
                    fontWeight: "700",
                    lineHeight: "18.9px",
                    color: "#FFFFFF",
                    border: "none",
                    marginLeft: "12px",
                  }}
                  onClick={() => {
                    if (loading === false) {
                      statusUpdateApi();
                    }
                  }}
                >
                  {status} all tickets
                </button>
              )}
              {status === "" && (
                <button
                  style={{
                    marginRight: "4px",
                    height: "40px",
                    borderRadius: "100px",
                    padding: "10px 28px 10px 28px",
                    gap: "10px",
                    backgroundColor: "#2C8C53",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    cursor: "pointer",
                    fontFamily: "Satoshi",
                    fontSize: "14px",
                    fontWeight: "700",
                    lineHeight: "18.9px",
                    color: "#FFFFFF",
                    border: "none",
                    marginLeft: "12px",
                  }}
                  onClick={() => {
                    if (loading === false) {
                      statusUpdateApi();
                    }
                  }}
                >
                  Save
                </button>
              )}
              <div
                onClick={onHide}
                className="style-justify-center cursor-pointer"
                style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "100px",
                  border: "1px solid #EBEBEB",
                }}
              >
                <img src={ModalCloseIcon} alt="close" />
              </div>
              {/*  <ModalCloseIcon
                style={{ cursor: "pointer" }}
                onClick={onHide}
              /> */}
            </div>
          </div>

          <div style={{ flex: 1, minHeight: 0, overflow: "hidden", display: "flex", flexDirection: "column" }}>
            <Row style={{ display: "flex", flexWrap: "wrap", height: "100%", minHeight: 0, margin: 0 }}>
              <Col sm={12} md={6} lg={4} style={{ height: "100%", overflowY: "auto", paddingRight: "16px" }}>
                <div>
                  <div className="sub-title">Default settings</div>
                  <Row xs={12} style={{ display: "flex", flexWrap: "wrap" }}>
                    <Col sm={12} md={6} style={{ marginTop: "16px" }}>
                      <h1
                        style={{
                          fontFamily: "Satoshi",
                          fontWeight: "500",
                          fontSize: "13px",
                          lineHeight: "17.55px",
                          color: "#212129",
                        }}
                      >
                        Status
                      </h1>
                      <select
                        className="w-100"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                        style={{
                          /*  width: "264.75px", */
                          height: "40px",
                          fontFamily: "Satoshi",
                          fontSize: "14px",
                          fontWeight: "500",
                          lineHeight: "18.9px",
                          color: "#8790A1",
                          border: "0.7px solid #E5E5E5",
                          padding: "0 16px",
                          backgroundColor: "#FFFFFF",
                          borderRadius: "10px",
                        }}
                      >
                        <option value="">Select</option>
                        <option value="In Progress">In Progress</option>
                        <option value="Hold">Hold</option>
                        <option value="Closed">Closed</option>
                      </select>

                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validations.status}
                      </span>
                    </Col>

                    <Col md={6} style={{ marginTop: "16px" }}>
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "13px",
                          fontWeight: "500",
                          lineHeight: "17.55px",
                          color: "#212129",
                          marginBottom: "8px",
                        }}
                      >
                        Default Project
                      </p>

                      <SearchWithAPI
                        onDropdownChange={handleProjectDropdownChange}
                        apiUrl={`get_project`}
                        placeholder={"Project"}
                        selectedValue={
                          selectedProjectOption != null
                            ? selectedProjectOption.label
                            : ""
                        }
                        selectedOption={selectedProjectOption}
                      />

                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validations.project_id}
                      </span>
                    </Col>
                    <Col md={6} style={{ marginTop: "16px" }}>
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "13px",
                          fontWeight: "500",
                          lineHeight: "17.55px",
                          color: "#212129",
                          marginBottom: "8px",
                        }}
                      >
                        Default Component
                      </p>

                      <SearchWithAPI
                        onDropdownChange={handleComponentDropdownChange}
                        apiUrl={`get_component`}
                        placeholder={"Component"}
                        selectedValue={
                          selectedComponentOption != null
                            ? selectedComponentOption.label
                            : ""
                        }
                        selectedOption={selectedComponentOption}
                      />

                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validations.component_id}
                      </span>
                    </Col>
                    <Col md={6} style={{ marginTop: "16px" }}>
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "13px",
                          fontWeight: "500",
                          lineHeight: "17.55px",
                          color: "#212129",
                          marginBottom: "8px",
                        }}
                      >
                        Default Team
                      </p>

                      <SearchWithAPI
                        onDropdownChange={handleTeamDropdownChange}
                        apiUrl={"get_team"}
                        placeholder={
                          "Team"
                        }
                        selectedValue={
                          selectedTeamOption != null
                            ? selectedTeamOption.label
                            : ""
                        }
                        selectedOption={selectedTeamOption}
                      />

                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validations.component_id}
                      </span>
                    </Col>
                    <Col md={6} style={{ marginTop: "16px" }}>
                      <p
                        style={{
                          fontFamily: "Satoshi",
                          fontSize: "13px",
                          fontWeight: "500",
                          lineHeight: "17.55px",
                          color: "#212129",
                          marginBottom: "8px",
                        }}
                      >
                        Default Assign To
                      </p>

                      <SearchWithAPI
                        onDropdownChange={handleAssignToDropdownChange}
                        apiUrl={"get_employee"}
                        params={
                          selectedTeamOption?.value
                            ? { team_id: selectedTeamOption.value }
                            : {}
                        }
                        placeholder={"Assign To"}
                        selectedValue={
                          selectedAssignToOption != null
                            ? selectedAssignToOption.label
                            : ""
                        }
                        selectedOption={selectedAssignToOption}
                      />

                      <span
                        style={{
                          fontSize: "12px",
                          fontWeight: 400,
                          color: "#FF4444",
                        }}
                      >
                        {validations.component_id}
                      </span>
                    </Col>
                  </Row>
                </div>
                {/*  <button style={{marginTop:'4px', height:'40px',width:'100%', borderRadius:'100px',padding:'10px 28px 10px 28px',gap:'10px',backgroundColor:'#6929E2',display:'flex',justifyContent:'center',alignItems:'center',cursor:'pointer',fontFamily: 'Satoshi',fontSize: '14px',fontWeight: '700',lineHeight: '18.9px',color:'#FFFFFF',border:'none',marginLeft:'12px'}} onClick={()=>{}}>
                                Apply to all tickets
                            </button>  */}
                <div
                  className="my-2"
                  style={{ height: "1px", background: "#E5E5E5" }}
                ></div>
                <div className="sub-title">Remarks settings</div>
                <div className="style-justify-center mt-2">
                  <div className="me-2" style={{ width: "100%" }}>
                    <label
                      className="style-justify-center"
                      style={{
                        width: "100%",
                        height: "44px",
                        borderRadius: "100px",
                        background:
                          remarkType === "single" ? "#F5F0FF" : "#FFFFFF",
                        border: "0.6px solid #EBEBEB",
                        color: remarkType === "single" ? "#6929E2" : "#212129",
                        fontSize: "14px",
                        fontWeight: "700",
                      }}
                    >
                      <input
                        type="radio"
                        name="remarkType"
                        value="single"
                        checked={remarkType === "single"}
                        onChange={handleChangeRadio}
                        style={{ color: "#6929E2" }}
                      />
                      <div className="ps-2">Single remarks</div>
                    </label>
                  </div>
                  <div style={{ width: "100%" }}>
                    <label
                      className="style-justify-center"
                      style={{
                        height: "44px",
                        borderRadius: "100px",
                        background:
                          remarkType === "individual" ? "#F5F0FF" : "#FFFFFF",
                        border: "0.6px solid #EBEBEB",
                        color:
                          remarkType === "individual" ? "#6929E2" : "#212129",
                        fontSize: "14px",
                        fontWeight: "700",
                      }}
                    >
                      <input
                        type="radio"
                        name="remarkType"
                        value="individual"
                        checked={remarkType === "individual"}
                        onChange={handleChangeRadio}
                      />
                      <div className="ps-2">Individual remarks</div>
                    </label>
                  </div>
                </div>
                {remarkType === "single" && (
                  <div className="mt-2">
                    <div
                      style={{
                        paddingTop: "6px",
                        paddingBottom: "6x",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "13px",
                        fontWeight: "500",
                        color: "#212129",
                      }}
                    >
                      Remarks{" "}
                      <span
                        style={{
                          paddingLeft: "4px",
                          fontSize: "13px",
                          fontWeight: "500",
                          color: "#212129",
                          opacity: "0.6",
                        }}
                      >
                        (Apply to all tickets)
                      </span>
                    </div>
                    <textarea
                      type="text"
                      placeholder=" "
                      className="form-control mt-1"
                      value={descriptionInputValue}
                      rows={3}
                      onChange={(event) => {
                        setDescriptionInputValue(event.target.value); // Update state with input value
                      }}
                    />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                      }}
                    >
                      {validations.description}
                    </span>
                  </div>
                )}
              </Col>
              <Col sm={12} md={6} lg={8} style={{ height: "100%", display: "flex", flexDirection: "column", minHeight: 0, paddingLeft: "16px" }}>
                <div className="sub-title" style={{ flexShrink: 0, marginBottom: "8px" }}>
                  Tickets - {selectedTicketList.length}
                </div>
                <div
                  style={{
                    background: "#F8F8F8",
                    borderRadius: "24px",
                    padding: "16px",
                    flex: 1,
                    minHeight: 0,
                    overflowY: "auto",
                  }}
                >
                  {selectedTicketList.map((item, index) => {
                    return (
                      <div
                        className="mb-2"
                        style={{
                          background: "#FFFFFF",
                          borderRadius: "16px",
                          padding: "16px",
                        }}
                      >
                        <div className="style-justify-start">
                          <div>
                            <input
                              type="checkbox"
                              id="expected_date"
                              onClick={(e) => {
                                if (e.target) {
                                  const tempList = [...selectedTicketList];
                                  if (tempList[index] !== undefined) {
                                    tempList[index].isChecked =
                                      !tempList[index].isChecked;
                                    setSelectedTicketList(tempList);
                                  }
                                  /* setIsChecked(e.target.checked); */
                                }
                              }}
                              checked={item.isChecked}
                            />
                          </div>
                          <div
                            style={{
                              paddingLeft: "8px",
                              fontSize: "14px",
                              fontWeight: "900",
                              color: "#6929E2",
                            }}
                          >
                            {item.code ?? ""}
                          </div>
                          <div
                            style={{
                              paddingLeft: "6px",
                              fontSize: "13px",
                              fontWeight: "500",
                              color: "#212129",
                              opacity: "0.6",
                            }}
                          >
                            {" "}
                            - {item.title ?? ""}
                          </div>
                        </div>
                        <Row
                          xs={12}
                          style={{ display: "flex", flexWrap: "wrap" }}
                        >
                          <Col md={6} style={{ marginTop: "12px" }}>
                            <div
                              style={{
                                fontFamily: "Satoshi",
                                fontSize: "13px",
                                fontWeight: "500",
                                lineHeight: "17.55px",
                                color: "#212129",
                                marginBottom: "6px",
                              }}
                            >
                              Project<span style={{ color: "red" }}> *</span>
                            </div>

                            <SearchWithAPI
                              searchId={index}
                              onChangeIndex={{ parentIndex: index }}
                              onDropdownChange={handleProjectListChange}
                              apiUrl={`get_project`}
                              placeholder={"Project"}
                              selectedOption={item.projectOption}
                            />
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {getErrorMsg(index, "project_id")}
                            </span>
                          </Col>
                          <Col md={6} style={{ marginTop: "12px" }}>
                            <div
                              style={{
                                fontFamily: "Satoshi",
                                fontSize: "13px",
                                fontWeight: "500",
                                lineHeight: "17.55px",
                                color: "#212129",
                                marginBottom: "6px",
                              }}
                            >
                              Component<span style={{ color: "red" }}> *</span>
                            </div>

                            <SearchWithAPI
                              searchId={index}
                              onChangeIndex={{ parentIndex: index }}
                              onDropdownChange={handleComponentListChange}
                              apiUrl={`get_component`}
                              placeholder={"Component"}
                              selectedOption={item.componentOption}
                            />

                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {getErrorMsg(index, "component_id")}
                            </span>
                          </Col>
                          <Col md={6} style={{ marginTop: "12px" }}>
                            <div
                              style={{
                                fontFamily: "Satoshi",
                                fontSize: "13px",
                                fontWeight: "500",
                                lineHeight: "17.55px",
                                color: "#212129",
                                marginBottom: "6px",
                              }}
                            >
                              Team<span style={{ color: "red" }}> *</span>
                            </div>

                            <SearchWithAPI
                              searchId={index}
                              onChangeIndex={{ parentIndex: index }}
                              onDropdownChange={handleTeamListChange}
                              apiUrl={`get_team`}
                              placeholder={"Team"}
                              selectedOption={item.teamOption}
                            />
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {getErrorMsg(index, "team_id")}
                            </span>
                          </Col>
                          <Col md={6} style={{ marginTop: "12px" }}>
                            <div
                              style={{
                                fontFamily: "Satoshi",
                                fontSize: "13px",
                                fontWeight: "500",
                                lineHeight: "17.55px",
                                color: "#212129",
                                marginBottom: "6px",
                              }}
                            >
                              Assign To<span style={{ color: "red" }}> *</span>
                            </div>

                            <SearchWithAPI
                              searchId={index}
                              onChangeIndex={{ parentIndex: index }}
                              onDropdownChange={handleAssignToListChange}
                              apiUrl={"get_employee"}
                              params={
                                item.teamOption?.value
                                  ? { team_id: item.teamOption.value }
                                  : {}
                              }
                              placeholder={"Assign To"}
                              selectedValue={
                                item.assignToOption != null
                                  ? item.assignToOption.label
                                  : ""
                              }
                              selectedOption={item.assignToOption}
                            />

                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {getErrorMsg(index, "component_id")}
                            </span>
                          </Col>
                          {status === "Closed" && (
                            <Col sm={6}>
                              <div
                                style={{
                                  paddingTop: "6px",
                                  paddingBottom: "6px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "start",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  color: "#212129",
                                }}
                              >
                                Work Duration
                              </div>
                              <input
                                className="w-100"
                                id="est"
                                type="text"
                                value={item.work_duration}
                                onChange={(event) => {
                                  const inputText = event.target.value;
                                  if (/^\d{0,2}(:\d{0,2})?$/.test(inputText)) {
                                    if (lastKey === "Backspace") {
                                      const tempList = [...selectedTicketList];
                                      if (tempList[index] !== undefined) {
                                        tempList[index].work_duration =
                                          event.target.value;
                                        setSelectedTicketList(tempList);
                                      }
                                    } else {
                                      const tempList = [...selectedTicketList];
                                      if (tempList[index] !== undefined) {
                                        tempList[index].work_duration =
                                          inputText.length === 2
                                            ? inputText + ":"
                                            : inputText;
                                        setSelectedTicketList(tempList);
                                      }
                                    }
                                  }
                                }}
                                onKeyDown={(event) => {
                                  setLastKey(event.key);
                                }}
                                style={{
                                  height: "44px",
                                  borderRadius: "10px",
                                  gap: "77px",
                                  padding: "16px",
                                  border: "0.7px solid #E5E5E5",
                                  fontFamily: "Satoshi",
                                  fontWeight: "500px",
                                  fontSize: "14px",
                                  lineHeight: "18.9px",
                                  color: "#21272C",
                                  backgroundColor: "#FFFFFF",
                                }}
                                placeholder="hh:mm"
                                maxLength={5}
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "#FF4444",
                                }}
                              >
                                {getErrorMsg(index, "work_duration")}
                              </span>
                            </Col>
                          )}
                          {status === "Closed" && (
                            <Col sm={6}>
                              <div
                                style={{
                                  paddingTop: "6px",
                                  paddingBottom: "6px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "start",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  color: "#212129",
                                }}
                              >
                                Closing Date
                              </div>
                              <DatePicker
                                selected={item.closing_date ? moment(item.closing_date, ["YYYY-MM-DDTHH:mm", "YYYY-MM-DD", "DD-MM-YYYY HH:mm", "DD-MM-YYYY"]).toDate() : null}
                                onChange={(date) => {
                                  const tempList = [...selectedTicketList];
                                  if (tempList[index] !== undefined) {
                                    tempList[index].closing_date = date ? moment(date).format("YYYY-MM-DDTHH:mm") : "";
                                    setSelectedTicketList(tempList);
                                  }
                                }}
                                showTimeInput
                                timeInputLabel="Enter Time:"
                                dateFormat="dd-MM-yyyy hh:mm aa"
                                placeholderText="dd-mm-yyyy hh:mm am/pm"
                                customInput={<TicketDateInput placeholder="Select closing date" />}
                                className="date-picker w-100"
                                popperClassName="expected-date-popper"
                                portalId="portal-root"
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "#FF4444",
                                }}
                              >
                                {getErrorMsg(index, "closing_date")}
                              </span>
                            </Col>
                          )}
                          {status === "Hold" && (
                            <Col sm={6}>
                              <div
                                style={{
                                  paddingTop: "6px",
                                  paddingBottom: "6px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "start",
                                  fontSize: "13px",
                                  fontWeight: "500",
                                  color: "#212129",
                                }}
                              >
                                Expected Date
                              </div>
                              <DatePicker
                                selected={item.expected_date ? moment(item.expected_date, ["YYYY-MM-DDTHH:mm", "YYYY-MM-DD", "DD-MM-YYYY HH:mm", "DD-MM-YYYY"]).toDate() : null}
                                onChange={(date) => {
                                  const tempList = [...selectedTicketList];
                                  if (tempList[index] !== undefined) {
                                    tempList[index].expected_date = date ? moment(date).format("YYYY-MM-DDTHH:mm") : "";
                                    setSelectedTicketList(tempList);
                                  }
                                }}
                                showTimeInput
                                timeInputLabel="Enter Time:"
                                dateFormat="dd-MM-yyyy hh:mm aa"
                                placeholderText="dd-mm-yyyy hh:mm am/pm"
                                customInput={<TicketDateInput placeholder="Select expected date" />}
                                className="date-picker w-100"
                                popperClassName="expected-date-popper"
                                portalId="portal-root"
                              />
                              <span
                                style={{
                                  fontSize: "12px",
                                  fontWeight: 400,
                                  color: "#FF4444",
                                }}
                              >
                                {getErrorMsg(index, "expected_date")}
                              </span>
                            </Col>
                          )}
                        </Row>
                        {remarkType === "individual" && (
                          <div className="mt-2">
                            <div
                              style={{
                                paddingBottom: "4x",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "start",
                                fontSize: "13px",
                                fontWeight: "500",
                                color: "#212129",
                              }}
                            >
                              Remarks
                            </div>
                            <textarea
                              type="text"
                              placeholder=" "
                              className="form-control mt-1"
                              value={item.description}
                              rows={1}
                              onChange={(event) => {
                                const tempList = [...selectedTicketList];
                                if (tempList[index] !== undefined) {
                                  tempList[index].description =
                                    event.target.value;
                                  setSelectedTicketList(tempList);
                                }
                              }}
                            />
                            <span
                              style={{
                                fontSize: "12px",
                                fontWeight: 400,
                                color: "#FF4444",
                              }}
                            >
                              {getErrorMsg(index, "description")}
                            </span>
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </Col>
            </Row>

            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BulkStatusUpdateModal;
